<template>
  <div class="multiple-choice-component question-type-component">
    <div class="hint-text" v-if="$props.question.hint" v-html="$props.question.hint.get()"></div>
    <div class="ui-option-fields-wrapper">
      <RadioComponent v-for="(option, i) in $props.question.options"
                      v-model="submission['root'][$props.question.path]"
                      :val="option.value"
                      :label="option.name.get()"
                      @update:model-value="emit('change')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import QualityMentoringFormQuestion from '../../models/QualityMentoringFormQuestion';

const emit = defineEmits(['change']);

const props = defineProps({
  question: QualityMentoringFormQuestion,
  submission: Object
})

if(!props.submission['root']) {
  props.submission['root'] = {};
}

function clear() {
  if(props.submission['root']) {
    delete props.submission['root'][props.question.path];
  }
}

defineExpose({
  clear
})
</script>
